/**
 * Provides functions for working with the Font Service API
 *
 * http://swagger.na.sas.com/apis/fonts/v3/redoc.html
 */
/**
 * Fetches font definitions from the server.
 */
export async function fetchFontDefinitions(serverUrl) {
    var _a;
    // `limit` is needed because its default value is 10, and there
    // are about 100 fonts that we need to add.
    const fontsUrl = `${serverUrl}/fonts/fonts?limit=1000`;
    const response = await fetch(fontsUrl, {
        credentials: 'include',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok || response.url.includes('/SASLogon/')) {
        return Promise.reject('Unable to fetch fonts');
    }
    const fontDefinitions = (await response.json());
    return (_a = fontDefinitions.items) !== null && _a !== void 0 ? _a : [];
}
